module.exports = __webpack_public_path__ + "img/quack.c4004610.jpg";